import axios from "axios";
import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { socketContext } from "../../../../../../App";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../../../../CustomHooks/useVideoHandleS3";

const CreatePostModal = (props) => {
  const { groupId, setFanPost } = props;
  const { slug } = useParams();
  const socketData = useContext(socketContext);

  const [description, setDescription] = useState("");

  const [postImg, setPostImg] = useState("");
  const [postVideo, setPostVideo] = useState("");

  const [file, setFile] = useState("");
  const [video, setVideo] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [videodelKey, setVideoDelKey] = useState(null);

  const [fileUrl, fileKey, progressbar] = useFileHandleS3(
    file,
    "fangroup/images",
    videodelKey
  );

  const [videoUrl, videoKey, progress] = useVdieoHandleS3(
    video,
    "fangroup/videos",
    delKey
  );

  const handleBanner = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const handleVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const changeVideo = (event) => {
    setVideo(event.target.files[0]);
    setPostVideo(URL.createObjectURL(event.target.files[0]));
  };

  const clearState = () => {
    setDescription("");
    setFile("");
    setVideo("");
    props.onHide();
  };

  const createPost = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("description", description);
    formData.append("image", fileKey);
    formData.append("video", videoKey);
    formData.append("slug", slug);

    await axios.post(`/api/user/fan/group/post/store`, formData).then((res) => {
      if (res.data.status === 200) {
        clearState();
        // setFanPost([res.data.post, ...props.fanPost]);
        // props.fanPostShowModel(false);

        swal("Posted", res.data.message, "success");
        // socketData.emit("postFanGroupPost", groupId);
        // socketData.on("getFanGroupPost", (data) => {
        //   axios.get(`/api/user/fan/group/post/show/${slug}`).then((res) => {
        //     if (res.status === 200) {
        //       setFanPost(res.data.fanPost);
        //       props.fanPostShowModel(false);
        //     }
        //   });
        // });
      }
    });
  };
  console.log("========>", slug);
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="fan-body-moadl"
      >
        <form onSubmit={createPost}>
          <div className="fan-bg-info rounded-3">
            <div className="d-flex justify-content-between px-3 pt-3 ">
              <div className="fan-head-modal">
                <h4>Create a post </h4>
              </div>
              <div className="d-flex justify-content-end ">
                <i
                  class="fas fa-times-circle text-danger fan-cencle-modal fan-post-cursor "
                  onClick={clearState}
                ></i>
              </div>
            </div>
            <div className="under-line"></div>

            <div className="col-12 p-3 ">
              {props?.fanPostType === "allPost" ? (
                <>
                  {/* TeaxtArea */}
                  <div
                    class="fan-div-text form-control w-100"
                    contenteditable="true"
                    onInput={(e) => {
                      setDescription(e.currentTarget.textContent);
                    }}
                  ></div>
                  {fileUrl ? (
                    <div className="fan-video-cencel">
                      <img src={fileUrl} className=" img-fluid" alt="" />
                      <div class="fan-top-right">
                        <i
                          class="fas fa-times-circle text-warning fan-post-cursor "
                          onClick={() => (props.onHide, setPostImg(""))}
                        ></i>
                      </div>
                    </div>
                  ) : null}

                  {videoUrl ? (
                    <div className="fan-video-cencel">
                      <video
                        src={videoUrl}
                        width="100%"
                        height="270px"
                        controls
                        className="m-0 p-0"
                      />

                      <div class="fan-top-right">
                        <i
                          class="fas fa-times-circle text-warning   fan-post-cursor"
                          onClick={() => (props.onHide, setPostVideo(""))}
                        ></i>
                      </div>
                    </div>
                  ) : null}

                  {file && !fileUrl && (
                    <MediaUploadProgressBar progress={progressbar} />
                  )}

                  {video && !videoUrl && (
                    <MediaUploadProgressBar progress={progress} />
                  )}
                </>
              ) : (
                <>
                  {file.name == null && video.name == null ? (
                    <div className="d-flex justify-content-center rounded-3 align-items-center fan-card-photo">
                      {props?.fanPostType === "photoPost" ? (
                        <label
                          htmlFor="photo"
                          className="rounded-3 px-2 fan-select-photo"
                        >
                          <i className=" fan-photo-big fa-solid fa-image fan-post-cursor"></i>
                        </label>
                      ) : (
                        <label
                          htmlFor="Video"
                          className="rounded-3 px-2 fan-select-photo"
                        >
                          <i className=" fan-photo-big fa-solid fa-video fan-post-cursor"></i>
                        </label>
                      )}

                      {props?.fanPostType === "photoPost" ? (
                        <input
                          type="file"
                          id="photo"
                          className="form-control d-none"
                          onChange={(e) => handleBanner(e.target.files)}
                          accept="image/*"
                        />
                      ) : (
                        <input
                          type="file"
                          id="Video"
                          className="form-control d-none"
                          onChange={(e) => handleVideo(e.target.files)}
                          accept="video/*"
                        />
                      )}
                    </div>
                  ) : (
                    <div className="col-12  ">
                      {fileUrl && (
                        <img src={fileUrl} className=" img-fluid" alt="" />
                      )}

                      {videoUrl && (
                        <video
                          src={videoUrl}
                          width="100%"
                          height="270px"
                          controls
                          className="m-0 p-0"
                        />
                      )}
                      {file && !fileUrl && (
                        <MediaUploadProgressBar progress={progressbar} />
                      )}

                      {video && !videoUrl && (
                        <MediaUploadProgressBar progress={progress} />
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="col-12 d-flex px-2 pb-3 justify-content-between align-items-center">
              <div className="d-flex">
                {props?.fanPostType === "allPost" ? (
                  <>
                    <span className="btnVideo card-bg1 mx-2 d-flex align-items-center">
                      <label htmlFor="photo">
                        {" "}
                        <i className=" fan-iconP fa-solid fa-image fan-post-cursor"></i>
                      </label>
                      <input
                        type="file"
                        id="photo"
                        className="form-control d-none "
                        onChange={(e) => handleBanner(e.target.files)}
                        accept="image/*"
                      />
                    </span>

                    <span className="btnVideo card-bg1 d-flex align-items-center">
                      <label htmlFor="video">
                        {" "}
                        <i className=" fan-iconV fa-solid fa-video fan-post-cursor"></i>
                      </label>
                      <input
                        type="file"
                        id="video"
                        className="form-control d-none"
                        onChange={(e) => handleVideo(e.target.files)}
                        accept="video/*"
                      />
                    </span>
                  </>
                ) : null}
              </div>

              <div className="mx-2">
                <button
                  type="submit"
                  className="btn fan-btn-modal lead card-text px-4 "
                >
                  Post
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default CreatePostModal;
